import React, { Component } from 'react'
import PropTypes from 'prop-types'
import '../style/AudioOverlay.scss'
import { isPlaySoundPermissionActive } from '../common/Util'
import config from '../common/config'
import AppAnalytics from '../common/AppAnalytics'

class AudioOverlay extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isVisible: true
        }
    }

    handleTapToEnable = () => {
        // Track user clicking tap to enable sound
        AppAnalytics.trackAction('sound_enable_clicked', {})
        
        try {
            // Trigger audio unlock
            if (this.props.onAudioUnlock) {
                this.props.onAudioUnlock()
            }
            
            // Hide overlay
            this.setState({ isVisible: false })
            
            // Store session flag to prevent showing again during this session
            sessionStorage.setItem('audioEnabledThisSession', 'true')
            localStorage.setItem('audioEnabled', 'true')
            
            // Track successful sound enable
            AppAnalytics.trackAction('sound_enable_success', {})
        } catch (error) {
            // Track sound enable failure
            AppAnalytics.trackAction('sound_enable_failure', {
                error: error.message || 'Unknown error'
            })
            console.error('Sound enable failed:', error)
        }
    }

    componentDidMount() {
        // Check if overlay should be shown based on login status and feature flag
        sessionStorage.removeItem('audioEnabledThisSession')
        this.checkOverlayVisibility()
        
        // Set up periodic check for overlaysConfig if it's not available yet
        this.configCheckInterval = setInterval(() => {
            if (!this.props.overlaysConfig) {
                // Still waiting for overlaysConfig
            } else {
                clearInterval(this.configCheckInterval)
                this.checkOverlayVisibility()
            }
        }, 2000)
    }
    
    componentWillUnmount() {
        if (this.configCheckInterval) {
            clearInterval(this.configCheckInterval)
        }
    }

    checkOverlayVisibility = () => {
        const { isLoggedIn, overlaysConfig } = this.props
        
        // First check: User must be logged in
        if (!isLoggedIn) {
            this.setState({ isVisible: false })
            return
        }
        
        // Check if overlaysConfig is available yet
        if (!overlaysConfig) {
            this.setState({ isVisible: false })
            return
        }
        
        // Get current store ID for validation
        const currentStoreId = config.storeId()
        
        // Second check: playSoundPermission feature flag must be active and store ID must match
        const featureFlagResult = isPlaySoundPermissionActive(overlaysConfig, currentStoreId)
        
        if (!featureFlagResult) {
            this.setState({ isVisible: false })
            return
        }
        
        // Third check: Check if overlay was already shown this session
        const audioEnabledThisSession = sessionStorage.getItem('audioEnabledThisSession')
        if (audioEnabledThisSession === 'true') {
            this.setState({ isVisible: false })
            return
        }
        
        // All checks passed - show overlay
        this.setState({ isVisible: true })
    }

    componentDidUpdate(prevProps) {
        // Re-check visibility if login status or overlays config changes
        if (prevProps.isLoggedIn !== this.props.isLoggedIn || 
            prevProps.overlaysConfig !== this.props.overlaysConfig) {
            this.checkOverlayVisibility()
        }
    }

    render() {
        if (!this.state.isVisible) {
            return null
        }

        return (
            <div className="audio-overlay">
                <div className="audio-overlay-content">
                    <div className="audio-overlay-icon">
                        <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z" fill="currentColor"/>
                        </svg>
                    </div>
                    <h2 className="audio-overlay-title">Enable Sound Notifications</h2>
                    <p className="audio-overlay-description">
                        Tap to enable audio notifications for new orders and updates
                    </p>
                    <button 
                        className="audio-overlay-button"
                        onClick={this.handleTapToEnable}
                        type="button"
                    >
                        Tap to Enable Sound
                    </button>
                </div>
            </div>
        )
    }
}

AudioOverlay.propTypes = {
    onAudioUnlock: PropTypes.func,
    isLoggedIn: PropTypes.bool.isRequired,
    overlaysConfig: PropTypes.array,
    authObject: PropTypes.object
}

export default AudioOverlay
